import React, { Component, Fragment } from 'react';
import './PerformanceRow.css';


class DrawdownCompareRow extends Component {

    formatPercent(number) {
        const {
            type
        } = this.props;


        if ((type === 'beta') || (type === 'sharpeRatio')) {
            return (
                number !== null ? parseFloat(number).toFixed(2) : '-'
            );
        }

        return (
            number === null || isNaN(parseFloat(number)) ? '-' : `${parseFloat(number * 100).toFixed(2)}%`
        );
    }

    formatDate(string) {
        return new Date(string).toLocaleDateString([], { timeZone: 'UTC' });
    }

    render() {
        const {
            data,
            type,
            index
        } = this.props;

        const drawDownCompData = data.filter((x) => x.drawDownPerformance !== null).filter((x) => x.drawDownPerformance.length > 0);
        if (drawDownCompData) {
            let columns = drawDownCompData.map((value, idx) => {
                let y = value['drawDownPerformance'][index].drawPerf
                if (!value) {
                    return (<td  key={`column-${idx}`} className='textCenter'>-</td>);
                } else {
                    return (
                        <td  key={`column-${idx}`} className='textCenter'>
                            {this.formatPercent(y)}
                        </td>
                    );
                }
            });

            let y = drawDownCompData[0].drawDownPerformance
            if (type === 'compare') {
                let sDate = y[index].startDate;
                let eDate = y[index].endDate;
                return (
                    <Fragment key={`fragment-${index}`}>
                        <tr key={`row-${index}`} className='greyline' style={{ marginTop: '15px', paddingLeft: '0px', paddingright: '0px' }} >
                            <td className='textCenter'>
                                {this.formatDate(sDate)}
                            </td>
                            <td className='textCenter'>
                                {this.formatDate(eDate)}
                            </td>
                            {columns}
                        </tr>
                    </Fragment>
                );
            }
        }

        else
            return (
                null
            );

    }
}

export default DrawdownCompareRow;